import { featuresItems } from '@/mocks/anime';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            为什么超过千万动漫爱好者选择51动漫网
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresItems.map((item, idx) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-7 text-center hover:border-primary-200/50 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-14 h-14 mx-auto mb-4 rounded-2xl flex items-center justify-center ${
                idx === 0 ? 'bg-primary-100' : idx === 1 ? 'bg-accent-100' : idx === 2 ? 'bg-secondary-100' : 'bg-primary-100'
              }`}>
                <i className={`${item.icon} ${
                  idx === 0 ? 'text-primary-600' : idx === 1 ? 'text-accent-600' : idx === 2 ? 'text-secondary-600' : 'text-primary-600'
                } text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}